
/* injects from baggage-loader */

'use strict';

export default class ProductCreatorController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/product-creator/product-creator.controller.js